import React from 'react';
import { clsx } from 'clsx';
import { Icon } from '@/ui/icons/Icon';
import { formatAmountWithSpacesAndSymbol } from '@/lib/amountUtils';
import styles from './CreditLineConfirmationDetails.module.scss';
import { Button } from '@/ui/components/Button';
import { format } from 'date-fns';

export interface CreditLineConfirmationDetailsProps {
  creditLimit?: number;
  paymentDay?: number;
  finalDueDate?: Date;
  className?: string;
  showEditIcons?: boolean;
  onEditCreditLimit?: () => void;
  onEditPaymentDay?: () => void;
}

export const CreditLineConfirmationDetails: React.FC<
  CreditLineConfirmationDetailsProps
> = ({
  creditLimit,
  paymentDay,
  finalDueDate,
  className,
  showEditIcons = false,
  onEditCreditLimit,
  onEditPaymentDay,
}) => {
  return (
    <div className={clsx(styles.detailsSection, className)}>
      <div className={styles.sectionHeader}>
        <h3 className={styles.sectionTitle}>Detalii</h3>
      </div>

      <div className={styles.detailsCard}>
        {/* Credit Limit */}
        <div className={styles.detailRow}>
          <div className={styles.detailLeft}>
            <p className={styles.detailLabel}>Limita liniei de credit</p>
          </div>
          <div className={styles.detailRight}>
            <div className={styles.detailValue}>
              <span className={styles.detailText}>
                {formatAmountWithSpacesAndSymbol(creditLimit, 'lei')}
              </span>
              {showEditIcons && (
                <Button
                  trackingId="edit_credit_limit_credit_line_confirmation"
                  iconOnly
                  size="xsmall"
                  className={styles.editButton}
                  variant="outlined"
                  leftIcon={<Icon name="pen" className={styles.editIcon} />}
                  onClick={onEditCreditLimit}
                />
              )}
            </div>
          </div>
        </div>

        {/* Payment Day */}
        <div className={styles.detailRow}>
          <div className={styles.detailLeft}>
            <p className={styles.detailLabel}>Data scadenței</p>
          </div>
          <div className={styles.detailRight}>
            <div className={styles.detailValue}>
              <span className={styles.detailText}>{paymentDay}</span>
              {showEditIcons && (
                <Button
                  trackingId="edit_payment_day_credit_line_confirmation"
                  iconOnly
                  size="xsmall"
                  className={styles.editButton}
                  variant="outlined"
                  leftIcon={<Icon name="pen" className={styles.editIcon} />}
                  onClick={onEditPaymentDay}
                />
              )}
            </div>
          </div>
        </div>

        {/* Final Due Date */}
        {finalDueDate && (
          <div className={styles.detailRow}>
            <div className={styles.detailLeft}>
              <p className={styles.detailLabel}>Scadența finală</p>
            </div>
            <div className={styles.detailRight}>
              <div className={styles.detailValue}>
                <span className={styles.detailText}>
                  {format(finalDueDate, 'dd.MM.yyyy')}
                </span>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Additional Info */}
      <div className={styles.additionalInfo}>
        <p className={styles.infoText}>
          Viitoarele rate vor trebui platite până în data de {paymentDay} a
          următoarei luni dupa retragere
        </p>
      </div>
    </div>
  );
};
